export default __webpack_public_path__ + "static/media/BLR14.fd3f55ad.jpg";